import React, { useState } from 'react';
import { ToolsSidebar } from '@/components/tools/ToolsSidebar';
import { ImageWorkspace } from '@/components/tools/ImageWorkspace';
import { SidebarProvider } from '@/components/ui/sidebar';
import SEO from '@/components/SEO';

export interface UploadedImage {
  id: string;
  file: File;
  preview: string;
  name: string;
  size: number;
  dimensions?: { width: number; height: number };
  format: string;
  dpi?: number;
  selected?: boolean;
}

export type ToolType = 
  | 'upload'
  | 'enhance'
  | 'background-remove'
  | 'format-convert'
  | 'resize'
  | 'compress'
  | 'filters'
  | 'watermark'
  | 'embroidery'
  | 'product-photo'
  | 'social-media'
  | 'favicon-generator'
  | 'projects'
  | 'presets'
  | 'history'
  | 'export';

const ImageToolsHub = () => {
  const [images, setImages] = useState<UploadedImage[]>([]);
  const [activeTool, setActiveTool] = useState<ToolType>('upload');
  const [sessionId] = useState(() => crypto.randomUUID());

  return (
    <SidebarProvider>
      <SEO
        title="AI Image Tools Hub | Edit, Enhance & Convert"
        description="Complete suite of AI image tools. Enhance quality, remove backgrounds, convert formats, resize, compress, and add watermarks all in one place."
        keywords="ai image tools, photo editing tools, image converter, background remover, image resizer, watermark tool"
        url="/image-tools"
      />
      <div className="min-h-screen flex w-full bg-background">
        <ToolsSidebar activeTool={activeTool} onToolChange={setActiveTool} />
        <ImageWorkspace 
          images={images}
          setImages={setImages}
          activeTool={activeTool}
          sessionId={sessionId}
        />
      </div>
    </SidebarProvider>
  );
};

export default ImageToolsHub;
